import createOnClickTracker from '../utils/tracker';

export default function AOBannerWithTwoButtons() {
  const initiate = () => {
    const $cta = $('.js-ao-clp-banner-with-buttons__cta');
    $cta.click(createOnClickTracker('Banner with Two Buttons'));
  };

  return { initiate };
}
